var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3337 14.9987V11.6654C28.3337 6.9987 24.667 3.33203 20.0003 3.33203C15.3337 3.33203 11.667 6.9987 11.667 11.6654V14.9987C8.83366 14.9987 6.66699 17.1654 6.66699 19.9987V31.6654C6.66699 34.4987 8.83366 36.6654 11.667 36.6654H28.3337C31.167 36.6654 33.3337 34.4987 33.3337 31.6654V19.9987C33.3337 17.1654 31.167 14.9987 28.3337 14.9987ZM15.0003 11.6654C15.0003 8.83203 17.167 6.66536 20.0003 6.66536C22.8337 6.66536 25.0003 8.83203 25.0003 11.6654V14.9987H15.0003V11.6654Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.cfeb5fb89c4a5ec4d8177152b2ab4ad9.svg";
export { ForwardRef as ReactComponent };